import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { Box, Grid, Typography } from "@mui/material/";
import { strings } from "../../../common/i18n";
import actions from "../../../Store/actions";
import styles from "./styles";
import makeStyles from "@mui/styles/makeStyles";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../../../common/css/datePicker.css";
import datePickerStyles from "../../../common/css/datePickerStyles";
import { logToSentry } from "../../../config/Sentry/";

/***
Date Picker Config
*/
const datePickerConfig = {
    format: "MMMM d, yyyy h:mm aa",
    minDate: moment().toDate(),
    timeIntervals: 30,
    filterPassedTime: (time) => {
        const currentDate = new Date();
        const selectedDate = new Date(time);
        return currentDate.getTime() < selectedDate.getTime();
    }
};

/**
 * Audit Dates Component
 */
export default () => {
    const { auditsCreate } = useSelector((state) => state);
    const dispatch = useDispatch();
    const calStyles = makeStyles(datePickerStyles)();
    const classes = makeStyles(styles)();

    useEffect(() => {
        // Set current startDate and time
        try {
            dispatch(
                actions.auditsCreate.create.itemSet({
                    startDate: new Date()
                })
            );
        } catch (error) {
            console.error(error);
            logToSentry("In setting default start date:", { error });
        }
    }, []);

    const handleDateChange = (name: string, date: Date) => {
        dispatch(actions.auditsCreate.create.itemSet({ [name]: date }));
        // if user select only start date, make sure that it is =< than end date
        if (
            name === "startDate" &&
            new Date(date) > new Date(auditsCreate.endDate)
        ) {
            dispatch(
                actions.auditsCreate.create.itemSet({ ["endDate"]: date })
            );
        }
    };

    return (
        <Grid container className={classes.datesRoot}>
            <Grid item xs={6}>
                <Typography className={classes.dateTitle}>
                    Start Date
                </Typography>
                <Box className={calStyles.customDatePickerStyle}>
                    <DatePicker
                        showTimeSelect
                        minDate={datePickerConfig.minDate}
                        filterTime={datePickerConfig.filterPassedTime}
                        placeholderText={strings("startDate")}
                        timeIntervals={datePickerConfig.timeIntervals}
                        className={classes.datePickerStyle}
                        portalId="startDate-portal"
                        dateFormat={datePickerConfig.format}
                        value={auditsCreate.startDate}
                        selected={auditsCreate.startDate}
                        inline
                        showTimeInput
                        onChange={(dt) => {
                            handleDateChange("startDate", dt);
                        }}
                    />
                </Box>
            </Grid>
            <Grid item xs={6}>
                <Typography className={classes.dateTitle}>End Date</Typography>
                <Box className={calStyles.customDatePickerStyle}>
                    <DatePicker
                        showTimeSelect
                        minDate={auditsCreate.startDate}
                        filterTime={(time) => {
                            const currentDate = new Date();
                            const selectedDate = new Date(time);
                            return (
                                currentDate.getTime() < selectedDate.getTime()
                            );
                        }}
                        placeholderText={strings("endDate")}
                        timeIntervals={datePickerConfig.timeIntervals}
                        className={classes.datePickerStyle}
                        portalId="endDate-portal"
                        dateFormat={datePickerConfig.format}
                        value={
                            auditsCreate.endDate < auditsCreate.startDate
                                ? auditsCreate.startDate
                                : auditsCreate.endDate
                        }
                        selected={
                            auditsCreate.endDate < auditsCreate.startDate
                                ? auditsCreate.startDate
                                : auditsCreate.endDate
                        }
                        startDate={auditsCreate.startDate}
                        inline
                        showTimeInput
                        onChange={(dt) => {
                            handleDateChange("endDate", dt);
                        }}
                    />
                </Box>
            </Grid>
        </Grid>
    );
};
